export default __webpack_public_path__ + "static/power_media_3-cb874b47241383c087b83512e35f3ff2.webp";